import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=e6b76dc4&scoped=true&lang=html"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=e6b76dc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b76dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6b76dc4')) {
      api.createRecord('e6b76dc4', component.options)
    } else {
      api.reload('e6b76dc4', component.options)
    }
    module.hot.accept("./Homepage.vue?vue&type=template&id=e6b76dc4&scoped=true&lang=html", function () {
      api.rerender('e6b76dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homepage.vue"
export default component.exports